import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { dropdownDownArrow} from '../../../assets/images'

const DropdownItem = styled.div`
padding: ${props => props.itemPadding || '8px'};
border: 1px solid transparent;
cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
user-select: none;
font-weight: 600;
background-color: ${props => props.selected ? `#2168f3` : `white` };
color: ${props => props.selected ? `white` : '#4D6189' };
&:hover {
	background-color: #F1F5FF;
	color: #4D6189;
}
`

const DropdownList = ({list, selectedItem={}, itemPadding, onChange}) => {
  if (list?.length > 0){
    let output = list.map((item, index) => {
      let selected = false
      let name = item
      if (typeof(item) === "object"){
        selected = selectedItem && selectedItem.id === item.id ? true : false
        name = item.name
      }
      else {
        selected = selectedItem && selectedItem === item ? true : false
      }
      return(<DropdownItem key={index} itemPadding={itemPadding}  selected={selected} onClick={() =>onChange(item)}>{name}</DropdownItem>)
    })
    return output
  }
  else {
    return(<DropdownItem />)
  }
}

const Dropdown = ({title, list, selectedItem, toggleList, onChange, listOpen, padding, mr, dropDownIcon=dropdownDownArrow, marginTopOptions, borderRequired, optionsBorderColor, closeOnClickOverlay = false, itemPadding,isdisable=false, ...props}) => { 
  const dropdownRef = useRef();

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        toggleList();
      }
    }
  
    if (listOpen && closeOnClickOverlay) {
      document.addEventListener('mousedown', handleClickOutside);
    }
  
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [listOpen, toggleList, closeOnClickOverlay]);
  
  const onDropDownclick = () => {
    if(!isdisable){
      toggleList()
    }
  }
  
  return(
    <div ref={dropdownRef} className={`block relative ${props.disabled ? 'pointer-events-none' : ''} mt-${marginTopOptions} mr-${mr} bg-white z-30 `}>
      <div onClick={onDropDownclick} className='flex justify-center p-2 mb-0 border border-gray-200 rounded-lg items-center cursor-pointer h-full' >
        <p className='text-gray-300 font-bold mb-0'>{title}</p>
        <img src={dropDownIcon} className={`w-3 h-3 ml-2`}/>
      </div>
      {listOpen ? (<div className={`absolute max-h-56 overflow-y-auto overflow-x-hidden border border-gray-200 mt-1 rounded w-max shadow-md`} >
        <DropdownList itemPadding={itemPadding} fontSize={props.fontSize} list={list} selectedItem={selectedItem} onChange={onChange} />
      </div>
      ) : null}
    </div>
  )
}

Dropdown.defaultProps = {
  titleColor: 'darkGrey',
  optionsBorderColor: 'rgba(0, 0, 0, 0.1)',
  borderRequired: true,
  disabled: false
}

export default Dropdown;